import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./AuthBase.html';
import styles from './AuthBase-hashed.scss';
import GetVersionL10nId from 'gw-portals-platform-js/versionName/GetVersionL10nId';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default {
    template: hashedTemplate,
    controller: ['$scope', function ($scope) {
        $scope.getVersionL10nId = GetVersionL10nId;
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/AuthBase/index.js
// module id = 1325
// module chunks = 0